import { createContextStore } from 'easy-peasy';
import playerStore from './playerStore';
import jsonDataStore from './jsonDataStore';
import groupsStore from './groupsStore';
/**
 * create store model which contains PlayerStoreModel and ScalingStoreModel proerties
 */
var statesObj = {
    playerStore: playerStore,
    jsonDataStore: jsonDataStore,
    groupsStore: groupsStore,
};
/**
 *  this is used to create context of stateObj
 */
var globalStore = createContextStore(statesObj);
export default globalStore;
